import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=712f7ab5&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=712f7ab5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712f7ab5",
  null
  
)

export default component.exports